import React, { useEffect, useState } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import DonutRingChart from "./DonutRingChart";
import { ICosts, IDonutRingData } from "../../../types/IClubDetail";

interface ClubCostsProps {
  data: ICosts | undefined;
}

const ClubCosts: React.FC<ClubCostsProps> = ({ data }) => {
  const [donutRingData, setDonutRingData] = useState<IDonutRingData[] | undefined>();

  useEffect(() => {
    setDonutRingData([
      {
        color: "#00D1A8",
        value: data?.amortisations,
        text: data?.amortisationsText,
        label: "Amortisations & depreciations",
        Inferred: data?.isAmortisationInferred,
      },
      { color: "#FF7800", value: data?.personnel, text: data?.personnelText, label: "Personnel", Inferred: data?.isPersonnelInferred },
      {
        color: "#FFC2C2",
        value: data?.playerTrading,
        text: data?.playerTradingText,
        label: "player trading",
        Inferred: data?.isPlayerTradingInferred,
      },
      { color: "#C9F0B5", value: data?.other, text: data?.otherText, label: "Other", Inferred: data?.isOtherInferred },
    ]);
  }, [data]);

  return (
    <>
      <StyledHeader className="header-content">
        <LabelText className="drawer-title">Costs</LabelText>
      </StyledHeader>
      <DonutRingChart data={donutRingData} total={data?.totalCostsText} type="cost" />
    </>
  );
};

export default ClubCosts;
